import { render, staticRenderFns } from "./yizhan_list.vue?vue&type=template&id=d64a3cf4&scoped=true&"
import script from "./yizhan_list.vue?vue&type=script&lang=js&"
export * from "./yizhan_list.vue?vue&type=script&lang=js&"
import style0 from "./yizhan_list.vue?vue&type=style&index=0&id=d64a3cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64a3cf4",
  null
  
)

export default component.exports